import { styled } from '../../styled';
export var SelectMenuHeader = styled('div', { name: 'QuantumSelectMenuHeader' })(function (_a) {
    var theme = _a.theme;
    return ({
        padding: theme.spacing(2),
    });
});
